<template>
  <div>
    <form id="mPay" name="mPay" :action="submitURL" method="post">
      <input name="encryptedText" type="hidden" :value="encryptedText">
      <input name="signedText" type="hidden" :value="signedText">
      <input name="merchantId" type="hidden" :value="merchantId">
    </form>
  </div>
</template>

<script>
export default {
  name: 'FundRichfullDeposit',
  props: ['encryptedText', 'merchantId', 'signedText', 'submitURL'],
  mounted() {
    this.doSubmit()
  },
  methods: {
    doSubmit() {
      var theForm = document.getElementById('mPay')
      theForm.submit()
    }
  }
}
</script>
